<template>
  <span>
    <v-popover
      trigger="manual"
      :open="isOpen"
      :placement="popOverPosition"
      @auto-hide="closeToolTip"
      :popoverClass="popoverClass"
      :popoverWrapperClass="['info-container', popoverWrapperClass]"
      :autoHide="true"
      defaultWrapperClass="tooltip-icon"
    >
      <div
        v-if="isAllowList"
        class="cursor-pointer"
        @click.prevent="showToolTip"
      >
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.399 3.842V2.988H6.379V3.842H5.399ZM5.455 8V4.577H6.33V8H5.455Z"
            fill="#9B9B9B"
          />
          <circle cx="6" cy="6" r="5.5" stroke="#9B9B9B" />
        </svg>
      </div>

      <div v-else class="tooltip-icon" @click.prevent="showToolTip">
        {{ icon }}
      </div>

      <template slot="popover">
        <div class="tooltip-close-button" @click="closeToolTip">
          <svg
            width="7"
            height="7"
            viewBox="0 0 7 7"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M1 1L6.27273 6.65854" stroke="#24282C" />
            <path d="M6.27271 1L0.999977 6.65854" stroke="#24282C" />
          </svg>
        </div>

        <div class="tooltip-content">
          <p
            v-for="(content, index) in generatedContent"
            :key="index"
            v-html="content"
          ></p>
        </div>
      </template>
    </v-popover>
  </span>
</template>

<script>
export default {
  name: 'ToolTipInfo',
  props: {
    isAllowList: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: '?'
    },
    popOverPosition: {
      type: String,
      default: 'top'
    },
    popoverClass: {
      type: String,
      default: 'info'
    },
    popoverWrapperClass: {
      type: String,
      default: ''
    },
    popOverContent: {
      type: String,
      default: 'Lorem Ipsum, Lorem Ipsum'
    },
    isInfo: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpen: false
    }
  },
  methods: {
    showToolTip() {
      this.isOpen = true
    },
    closeToolTip() {
      this.isOpen = false
    }
  },
  computed: {
    generatedContent() {
      return this.popOverContent.split(';')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/global.scss';

.tooltip-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  background: transparent;
  width: 12px;
  height: 12px;
  font-size: 7px;
  text-align: center;
  border: 1px solid #9b9b9b;
  color: #9b9b9b;
  border-radius: 50%;
  cursor: pointer;
}

.tooltip-close-button {
  border: none;
  display: flex;
  justify-content: flex-end;
  padding: 0px;
  text-align: center;
  cursor: pointer;
  font-size: 0.8rem;
  font-weight: 600;
  position: absolute;
  right: 10px;
  top: 7px;
}

.tooltip-content {
  padding: 15px;
  background: #dfdad2;
  p {
    font-size: 0.625rem;
    line-height: 0.938rem;
    font-family: $inter;
    color: black;
  }
}
.default .tooltip-content {
  p {
    font-size: 0.825rem;
    line-height: 1.238rem;
  }
}
</style>
